import { useState, useEffect } from "react";
import PropTypes from 'prop-types';

export default function Toggle(props) {
    const [enabled, setEnabled] = useState(props.checked);

    useEffect(()=> {
        setEnabled(props.checked)
    }, [props.checked]);

    return (
        <div className={"flex items-center mb-2 px-1"+ (props.disabled? " pointer-events-none": " cursor-pointer pointer-events-auto")}>
            <label htmlFor={"toggle_" + props.label} className={"text-[11px] leading-[14px] tracking-[0px] flex-1 font-bold " + (props.disabled? "text-[#c0c0c0]": " cursor-pointer text-[#333333]")}
            >{props.label}</label>
            <div className="relative flex flex-col items-center justify-center overflow-hidden">
                <div className="flex">
                    <div className={"inline-flex relative items-center" + (props.disabled? "": " cursor-pointer")}>
                        <input
                            id={"toggle_" + props.label}
                            type="checkbox"
                            className="sr-only peer"
                            checked={enabled}
                            readOnly
                        />
                        <div
                            className="w-10 h-5 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5  after:left-[5px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-my-emerald"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

Toggle.propTypes = {
    label: PropTypes.string,
    checked:PropTypes.bool,
    disabled:PropTypes.bool
}
